import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import HeadsetIcon from "@material-ui/icons/Headset";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { GuestApi } from "../../utils/api";
import {
  getDeviceInfo,
  getLocationFromBrowser,
} from "../../utils/locationAndDeviceInfo";

import awraaq from "../../assets/img/logo2.svg";

const AwraaqLogos = () => {
  const [browserLocationData, setBrowserLocationData] = useState("");

  const pageStyle = {
    background: "linear-gradient(to bottom, white 220px, #faf7f0 345px)",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    fontFamily: "Arial, sans-serif",
    margin: 0,
    padding: 0,
    overflow: "hidden",
  };

  const logoContainerStyle = {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    marginTop: "30px",
    flexWrap: "wrap",
    gap: "20px",
  };

  const logoStyle = {
    width: "180px",
    marginBottom: "5px",
  };

  const headerLogoStyle = {
    height: "40px",
    marginBottom: "10px",
  };

  const baseLabelStyle = {
    fontSize: "18px",
    fontWeight: "bold",
    marginTop: "15px",
    letterSpacing: "0.5px",
    textDecoration: "none",
  };

  const blockTradeLabelStyle = {
    ...baseLabelStyle,
    color: "white",
  };

  const blockSharesLabelStyle = {
    ...baseLabelStyle,
    color: "white",
  };

  const informationLabelStyle = {
    ...baseLabelStyle,
    color: "white",
  };

  const headerStyle = {
    color: "#0d5c46",
    marginBottom: "10px",
    textAlign: "center",
    fontWeight: "bold",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  };

  const digitalTextStyle = {
    fontSize: "28px",
    fontWeight: "bold",
    color: "#0d5c46",
    marginTop: "1px",
    letterSpacing: "0.5px",
    textDecoration: "none",
  };

  const lineStyle = {
    height: "2px",
    backgroundColor: "#0d5c46",
    width: "100%",
    marginBottom: "40px",
  };

  const linkStyle = {
    textDecoration: "none",
    color: "inherit",
  };

  const mainSiteButtonStyle = {
    position: "absolute",
    top: "20px",
    left: "20px",
    backgroundColor: "transparent",
    color: "#0d5c46",
    border: "1px solid #0d5c46",
    borderRadius: "4px",
    padding: "8px 15px",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.3s ease",
    textDecoration: "none",
    letterSpacing: "0.5px",
    display: "flex",
    alignItems: "center",
  };

  const welcomeTextStyle = {
    marginRight: "10px",
    fontWeight: "500",
    fontSize: "14px",
    color: "#0d5c46",
  };

  const handleButtonHover = (e) => {
    e.currentTarget.style.backgroundColor = "#0d5c46";
    e.currentTarget.style.color = "white";
  };

  const handleButtonLeave = (e) => {
    e.currentTarget.style.backgroundColor = "transparent";
    e.currentTarget.style.color = "#0d5c46";
  };

  const footerStyle = {
    backgroundColor: "#faf7f0",
    color: "#0d5c46",
    width: "100%",
    padding: "15px 30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxSizing: "border-box",
  };

  const footerTextStyle = {
    fontSize: "14px",
    fontWeight: "500",
    textAlign: "center",
  };

  const containerWrapperStyle = {
    display: "flex",
    flexDirection: "column",
    width: "90%",
    maxWidth: "1000px",
    flexGrow: 1,
    justifyContent: "space-between",
    minHeight: "100vh",
  };

  const clientData = JSON.parse(localStorage.getItem("client_data") || "{}");
  const userName = clientData?.client?.first_name;
  const userLastName = clientData?.client?.last_name;
  const isMasterUser = clientData?.client?.is_master_user;
  const userInitials =
    userName
      ?.split(" ")
      .map((name) => name[0])
      .join("") || userName?.charAt(0) + (userLastName?.charAt(0) || "");

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Get logout data
  const refreshToken = clientData?.token?.refresh_token;
  const clientRefreshTokenId = clientData?.token?.client_refresh_token_id;
  const clientId = clientData?.client?.id;
  const sessionId = clientData?.session_id;
  const deviceInfo = getDeviceInfo();

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    async function fetchBrowserLocation() {
      const browserLocationData = await getLocationFromBrowser();
      setBrowserLocationData(browserLocationData);
    }

    fetchBrowserLocation();
  }, []);

  const handleLogout = async () => {
    try {
      const logoutBody = {
        refresh_token: refreshToken,
        client_refresh_token_id: clientRefreshTokenId,
        client_id: clientId,
        ip_address: "",
        location: browserLocationData,
        device: deviceInfo,
        session_id: sessionId,
      };

      const logoutResponse = await GuestApi.post("/client/logout", logoutBody);

      if (logoutResponse.status === 200) {
        console.log("Logout successful");
      }
    } catch (e) {
      const { response } = e;
      console.log(`😱 Logout API request failed:`, response);
    } finally {
      localStorage.removeItem("client_data");
      localStorage.removeItem("otp_login_data");
      localStorage.removeItem("otp_expire_at");
      localStorage.removeItem("otp_login_creds");

      // Redirect to home
      window.location.href = "/";
    }
  };

  const mainCardStyle = {
    backgroundColor: "transparent",
    borderRadius: "15px",
    boxShadow: "0 8px 16px rgba(0, 0, 0, 0.1)",
    maxWidth: "1000px",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    flexGrow: 1,
    padding: windowWidth < 500 ? "15px" : "30px",
  };

  const logoItemStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    cursor: "pointer",
    width: windowWidth < 600 ? "100%" : "230px",
    maxWidth: "300px",
    position: "relative",
    borderRadius: "10px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  };

  const blockTradeStyle = {
    ...logoItemStyle,
    backgroundColor: "#0d5c46",
  };

  const blockSharesStyle = {
    ...logoItemStyle,
    backgroundColor: "#ff9800",
  };

  const informationStyle = {
    ...logoItemStyle,
    backgroundColor: "#269d8c",
    position: "relative",
  };

  const comingSoonOverlayStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.80)",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 10,
    opacity: 0,
    transition: "opacity 0.3s ease",
    backdropFilter: "blur(3px)",
    WebkitBackdropFilter: "blur(3px)",
  };

  const comingSoonTextStyle = {
    color: "white",
    fontSize: "20px",
    fontWeight: "bold",
    textAlign: "center",
    letterSpacing: "2px",
    textShadow: "2px 2px 4px rgba(0, 0, 0, 0.8)",
    textTransform: "uppercase",
  };

  const userProfileStyle = {
    position: "absolute",
    top: "20px",
    right: "20px",
    display: windowWidth < 400 ? "none" : "flex",
    alignItems: "center",
    color: "#0d5c46",
    fontWeight: "500",
    fontSize: "14px",
  };

  const userAvatarStyle = {
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    backgroundColor: "#0d5c46",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "10px",
    fontWeight: "bold",
    fontSize: windowWidth < 400 ? "0" : "14px",
    cursor: "pointer",
  };

  // Custom dropdown styles to match the design
  const dropdownMenuStyle = {
    minWidth: "200px",
    borderRadius: "8px",
    border: "1px solid #e0e0e0",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    padding: "8px 0",
  };

  const dropdownItemStyle = {
    padding: "8px 16px",
    fontSize: "14px",
    color: "#333",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    "&:hover": { backgroundColor: "#f1f1f1" },
    borderBottom: "none",
  };

  const dropdownHeaderStyle = {
    padding: "12px 16px",
    borderBottom: "1px solid #e0e0e0",
    marginBottom: "4px",
  };

  const customDropdownStyle = `
  .custom-dropdown-toggle::after {
    display: none !important;
  }
  .custom-dropdown-toggle:focus {
    box-shadow: none !important;
  }
`;

  return (
    <>
      <style>{customDropdownStyle}</style>
      <div style={pageStyle}>
        <div style={containerWrapperStyle}>
          <div style={mainCardStyle}>
            <a
              href="http://awraaq.com/"
              target="_blank"
              rel="noopener noreferrer"
              style={mainSiteButtonStyle}
              onMouseOver={handleButtonHover}
              onMouseOut={handleButtonLeave}
            >
              AWRAAQ.COM
            </a>

            <div style={userProfileStyle}>
              <div style={welcomeTextStyle}>Welcome, {userName}!</div>
              <Dropdown alignRight>
                <Dropdown.Toggle
                  variant="link"
                  id="user-dropdown"
                  className="p-0 border-0 shadow-none"
                  style={{
                    ...userAvatarStyle,
                    backgroundColor: "#0d5c46",
                    textDecoration: "none",
                  }}
                  bsPrefix="custom-dropdown-toggle"
                >
                  {userInitials}
                </Dropdown.Toggle>

                <Dropdown.Menu style={dropdownMenuStyle}>
                  <div style={dropdownHeaderStyle}>
                    <div
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                        color: "#0d5c46",
                        marginBottom: "2px",
                        textAlign: "center",
                      }}
                    >
                      {userName} {userLastName}
                    </div>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        textAlign: "center",
                      }}
                    >
                      {isMasterUser ? "Master" : "Associate"}
                    </div>
                  </div>

                  {/* <Dropdown.Item href="#/contactus" style={dropdownItemStyle}>
                    <HeadsetIcon
                      style={{
                        color: "#0d5c46",
                        marginRight: "8px",
                        fontSize: "18px",
                      }}
                    />
                    <span>Contact Us</span>
                  </Dropdown.Item> */}

                  <Dropdown.Item
                    onClick={handleLogout}
                    style={dropdownItemStyle}
                  >
                    <ExitToAppIcon
                      style={{
                        color: "#0d5c46",
                        marginRight: "8px",
                        fontSize: "18px",
                      }}
                    />
                    <span>Logout</span>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <div style={headerStyle}>
              <img src={awraaq} alt="AWRAAQ Logo" style={headerLogoStyle} />
              <div style={digitalTextStyle}>Digital</div>
            </div>
            <div style={lineStyle}></div>

            <div style={logoContainerStyle}>
              <a
                href="/#/institutional-dashboard/deals-and-market"
                rel="noopener noreferrer"
                style={linkStyle}
              >
                <div
                  style={blockTradeStyle}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "scale(1.05)";
                    e.currentTarget.style.boxShadow =
                      "0 10px 20px rgba(0, 0, 0, 0.15)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 8px rgba(0, 0, 0, 0.1)";
                  }}
                >
                  <img
                    src={"/logo99.png"}
                    alt="AWRAAQ Logo"
                    style={logoStyle}
                  />
                  <div style={blockTradeLabelStyle}>BlockTrade™</div>
                </div>
              </a>

              {isMasterUser && (
                <a
                  href="/#/shares-platform"
                  rel="noopener noreferrer"
                  style={linkStyle}
                >
                  <div
                    style={blockSharesStyle}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = "scale(1.05)";
                      e.currentTarget.style.boxShadow =
                        "0 10px 20px rgba(0, 0, 0, 0.15)";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = "scale(1)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 8px rgba(0, 0, 0, 0.1)";
                    }}
                  >
                    <img
                      src={"/logo99.png"}
                      alt="AWRAAQ Logo"
                      style={logoStyle}
                    />
                    <div style={blockSharesLabelStyle}>BlockShares™</div>
                  </div>
                </a>
              )}
              
              <div
                style={informationStyle}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 20px rgba(0, 0, 0, 0.15)";
                  const overlay = e.currentTarget.querySelector(
                    ".coming-soon-overlay"
                  );
                  if (overlay) overlay.style.opacity = "1";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 8px rgba(0, 0, 0, 0.1)";
                  const overlay = e.currentTarget.querySelector(
                    ".coming-soon-overlay"
                  );
                  if (overlay) overlay.style.opacity = "0";
                }}
              >
                <img src={"/logo99.png"} alt="AWRAAQ Logo" style={logoStyle} />
                <div style={informationLabelStyle}>BlockData™</div>
                <div
                  className="coming-soon-overlay"
                  style={comingSoonOverlayStyle}
                >
                  <div style={comingSoonTextStyle}>Coming Soon</div>
                </div>
              </div>
            </div>
          </div>

          <div style={footerStyle}>
            <div style={footerTextStyle}>
              AWRAAQ Digital for Information Technology Company © 2025.
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AwraaqLogos;
